<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Hồ sơ học sinh&nbsp;</span><breadcrumbs [items]="breadcrumbs"></breadcrumbs></div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <nz-upload
        class="flex items-start"
        nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        [nzHeaders]="{ authorization: 'authorization-text' }"
        (nzChange)="handleChange($event)"
        >
        <button 
        nz-button 
        class="flex items-center justify-center" 
        nzTooltipTitle="Xuất excel" 
        nzTooltipPlacement="bottom" 
        nz-tooltip
        >
          <i 
            nz-icon 
            nzType="file-excel" 
            nzTheme="twotone"
            >
          </i>
      </button>
      </nz-upload>
      <button 
        class="flex items-center justify-center" 
        nz-button 
        nzTooltipTitle="In" 
        nzTooltipPlacement="bottom" 
        nz-tooltip
        >
        <i 
          nz-icon 
          nzType="printer" 
          nzTheme="outline"
          >
        </i>
      </button>
      <button 
        class="flex items-center justify-center" 
        nz-button 
        nzTooltipTitle="Trích xuất dữ liệu" 
        nzTooltipPlacement="bottom" 
        nz-tooltip
      >
        <i 
          nz-icon 
          nzType="export" 
          nzTheme="outline"
          >
        </i>
      </button>
      <button 
        class="flex items-center justify-center" 
        nz-button 
        nzTooltipTitle="Thêm" 
        nzTooltipPlacement="bottom" 
        nz-tooltip
        (click)="showAddStudent()"
        >
        <i 
          nz-icon 
          nzType="user-add" 
          nzTheme="outline"
          >
        </i>
      </button>
      <button 
        class="flex items-center justify-center" 
        (click)="showDeleteStudent()"
        nz-button 
        nzType="primary" 
        nzTooltipTitle="Xóa" 
        nzTooltipPlacement="bottom" 
        nz-tooltip 
        nzDanger
      >
        <i 
          nz-icon 
          nzType="delete" 
          nzTheme="outline" 
          >
        </i>
      </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <nz-upload
          class="flex items-start"
          nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          [nzHeaders]="{ authorization: 'authorization-text' }"
          (nzChange)="handleChange($event)"
        >
          <button 
            nz-button 
            class="flex items-center justify-center" 
          >Xuất excel
          </button>
        </nz-upload>
        <button 
          class="flex items-center justify-center" 
          nz-button
          >In
        </button>
        <button 
          class="flex items-center justify-center" 
          nz-button
        >Trích xuất dữ liệu
        </button>
        <button 
          class="flex items-center justify-center" 
          nz-button
          (click)="showAddStudent()"
          >Thêm
        </button>
        <button 
          class="flex items-center justify-center" 
          (click)="showDeleteStudent()"
          nz-button 
          nzType="primary" 
          nzDanger
        >Xóa
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <nz-upload
          class="flex items-start"
          nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          [nzHeaders]="{ authorization: 'authorization-text' }"
          (nzChange)="handleChange($event)"
        >
          <button 
            nz-button 
            class="flex items-center justify-center" 
          >
            <i 
              nz-icon 
              nzType="file-excel" 
              nzTheme="twotone"
              >
            </i>Xuất excel
          </button>
        </nz-upload>
        <button 
          class="flex items-center justify-center" 
          nz-button 
          >
          <i 
            nz-icon 
            nzType="printer" 
            nzTheme="outline"
            >
          </i>In
        </button>
        <button 
          class="flex items-center justify-center" 
          nz-button
        >
          <i 
            nz-icon 
            nzType="export" 
            nzTheme="outline"
            >
          </i>Trích xuất dữ liệu
        </button>
        <button 
          class="flex items-center justify-center" 
          nz-button
          (click)="showAddStudent()"
          >
          <i 
            nz-icon 
            nzType="user-add" 
            nzTheme="outline"
            >
          </i>Thêm
        </button>
        <button 
          class="flex items-center justify-center" 
          (click)="showDeleteStudent()"
          nz-button 
          nzType="primary"
          nzDanger
        >
          <i 
            nz-icon 
            nzType="delete" 
            nzTheme="outline" 
            >
          </i>Xóa
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form [formGroup]="validateForm" class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="quanHuyen">Quận huyện</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
            <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="quanHuyen">
              <nz-option nzValue="256" nzLabel="Thành phố Bắc Ninh"></nz-option>
              <nz-option nzValue="258" nzLabel="Huyện Yên Phong"></nz-option>
              <nz-option nzValue="259" nzLabel="Huyện Quế Võ"></nz-option>
              <nz-option nzValue="260" nzLabel="Huyện Tiên Du"></nz-option>
              <nz-option nzValue="263" nzLabel="Huyện Gia Bình"></nz-option>
              <nz-option nzValue="264" nzLabel="Huyện Lương Tài"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="maHs">Mã học sinh</nz-form-label>
          <nz-form-control nzSpan="24" >
            <input nz-input  formControlName="maHs" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="hoTen">Họ tên</nz-form-label>
          <nz-form-control nzSpan="24" >
            <input nz-input  formControlName="hoTen" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="gioiTinh">Giới tính</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group formControlName="gioiTinh">
              <label nz-radio nzValue="tatCa">Tất cả</label>
              <label nz-radio nzValue="nam">Nam</label>
              <label nz-radio nzValue="nu">Nữ</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
      <ng-container *ngIf="!isCollapse" #pageExpandedSearch>
        <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="gioiTinh">Ngày sinh</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-range-picker formControlName="ngaySinh" (ngModelChange)="onChange($event)"></nz-range-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="danToc">Dân Tộc</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="danToc">
                <nz-option nzValue="256" nzLabel="Ba Na"></nz-option>
                <nz-option nzValue="258" nzLabel="Bố Y"></nz-option>
                <nz-option nzValue="259" nzLabel="Ê Đê"></nz-option>
                <nz-option nzValue="260" nzLabel="Brâu"></nz-option>
                <nz-option nzValue="263" nzLabel="Co"></nz-option>
                <nz-option nzValue="264" nzLabel="Cống"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="dienChinhSach">Diện chính sách</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="dienChinhSach">
                <nz-option nzValue="256" nzLabel="Bị bỏ rơi mất quyền nuôi dưỡng"></nz-option>
                <nz-option nzValue="258" nzLabel="Bị tàn tật khuyết tật"></nz-option>
                <nz-option nzValue="259" nzLabel="Con anh hùng"></nz-option>
                <nz-option nzValue="260" nzLabel="Con liệt sĩ"></nz-option>
                <nz-option nzValue="263" nzLabel="Con thương binh"></nz-option>
                <nz-option nzValue="264" nzLabel="Diện chính sách khác"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="khuyetTat">Khuyết tật</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Tất cả" formControlName="khuyetTat">
                <nz-option nzValue="256" nzLabel="Khuyết tật khác"></nz-option>
                <nz-option nzValue="258" nzLabel="Khuyết tật nghe nói"></nz-option>
                <nz-option nzValue="259" nzLabel="Khuyết tật nhìn"></nz-option>
                <nz-option nzValue="260" nzLabel="Khuyết tật thần kinh tâm thần"></nz-option>
                <nz-option nzValue="263" nzLabel="Khuyết tật trí tuệ"></nz-option>
                <nz-option nzValue="264" nzLabel="Khuyết tật vận động"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="diaChi">Địa chỉ</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <input nz-input  formControlName="diaChi" />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="namNhapHoc" >Năm nhập học</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
              <nz-date-picker nzMode="year" formControlName="namNhapHoc" (ngModelChange)="onChange($event)"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="daXepLop">Đã xếp lớp</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-radio-group formControlName="daXepLop">
                <label nz-radio nzValue="tatCa">Tất cả</label>
                <label nz-radio nzValue="nam">Có</label>
                <label nz-radio nzValue="nu">Không</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSm="12" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24" nzFor="lopHoc">Lớp Học</nz-form-label>
            <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">            
              <input nz-input formControlName="lopHoc"/>
            </nz-form-control>
          </nz-form-item>
        </div>
      </ng-container>
      <div *ngIf="this.divisibleForFour" nz-col nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">hi</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'" nz-tooltip (click)="toggleCollapse()"><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'">Tìm kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()"
            nzTooltipTitle="Xóa tìm kiếm" 
            nzTooltipPlacement="bottom" 
            nz-tooltip
          ><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'" 
            nzTooltipTitle="Tìm kiếm" 
            nzTooltipPlacement="bottom" 
            nz-tooltip><i nz-icon nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" (click)="resetForm()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'"><i nz-icon nzType="search" nzTheme="outline" ></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table
      #hi 
      nzOuterBordered
      nzShowSizeChanger 
      [nzData]="listOfData" 
      nzSize="small" 
      [nzScroll]="{ x: width +'px' }" 
      class="absolute w-full"
      [nzFrontPagination]="false"
      [nzTotal]="'40'"
      [nzPageSize]="'50'"
      [nzPageIndex]="'1'"
      [nzPageSizeOptions]= "[50, 100, 150]"
     >
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" nzLeft [nzSortFn]="sortNameFn" [nzSortDirections]="'ascend'" >STT</th>
          <th nzWidth="100px" nzLeft>Mã</th>
          <th nzWidth="200px"nzLeft>Họ đệm</th>
          <th nzWidth="100px"nzLeft [nzSortFn]="sortNameFn">Tên</th>
          <th nzWidth="100px">Giới tính</th>
          <th nzWidth="150px">Ngày sinh</th>
          <th nzWidth="150px">Năm nhập học</th>
          <th>Lớp học</th>
          <th nzRight  nzWidth="105px"></th>
          <!-- <th nzWidth="30px" nzRight></th>
          <th nzWidth="30px" nzRight></th>
          <th nzWidth="30px" nzRight></th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of hi.data">
          <td nzLeft>{{ data.numberIndex }}</td>
          <td nzLeft>{{ data.code }}</td>
          <td nzLeft>{{ data.firstName }}</td>
          <td nzLeft>{{ data.lastName }}</td>
          <td>{{ data.gender }}</td>
          <td>{{ data.dob }}</td>
          <td>{{ data.yoa }}</td>
          <td>{{ data.class }}</td>
          <td nzRight>
            <div nz-space nzAlign="end" class="space-align-block">
              <nz-space-item>
                <a nzTooltipTitle="Phục hồi mật khẩu" nzTooltipPlacement="top" nz-tooltip>
                  <i nz-icon nzType="redo" nzTheme="outline"></i>
                </a>
              </nz-space-item>
              <nz-space-item>
                <a class="text-green-600" nzTooltipTitle="Xếp lớp" nzTooltipPlacement="top" nz-tooltip>
                  <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
                </a>
              </nz-space-item>
              <nz-space-item>
                <a class="text-blue-600" nzTooltipTitle="Sửa" nzTooltipPlacement="top" nz-tooltip>
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                </a>
              </nz-space-item>
              <nz-space-item>
                <a class="text-red-600" nzTooltipTitle="Xóa" nzTooltipPlacement="top" nz-tooltip (click)="showDeleteStudent()">
                  <i nz-icon nzType="delete"nzTheme="outline"></i>
                </a>
              </nz-space-item>
            </div>
          </td>
          <!-- <td nzRight style="color:green">

          </td>
          <td nzRight style="color:#1890ff">

          </td>
          <td nzRight style="color:red">

          </td> -->
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>